var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { "hide-vertical-scroll": _vm.hideVerticalScroll },
      attrs: { id: "app" },
    },
    [
      _c("Header"),
      _c("transition", { attrs: { name: "fast-fade" } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showLoadingBlocker,
                expression: "showLoadingBlocker",
              },
            ],
            attrs: { id: "spinner-wrapper" },
          },
          [
            _c("div", { attrs: { id: "spinner-inner-wrapper" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showLoadingSpinner,
                      expression: "showLoadingSpinner",
                    },
                  ],
                  attrs: { id: "ball-wrapper" },
                },
                [
                  _c("div", { staticClass: "ball1" }),
                  _c("div", { staticClass: "ball2" }),
                  _c("div", { staticClass: "ball3" }),
                ]
              ),
              _c("br"),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showLoadingMessage && _vm.loadingMessage,
                      expression: "showLoadingMessage && loadingMessage",
                    },
                  ],
                  staticClass: "loading-message",
                },
                [_vm._v(" " + _vm._s(_vm.loadingMessage) + " ")]
              ),
            ]),
          ]
        ),
      ]),
      _c(
        "div",
        { attrs: { id: "app-wrapper" } },
        [
          _c(
            "transition",
            { attrs: { name: "zoom", mode: "out-in" } },
            [_c("router-view")],
            1
          ),
        ],
        1
      ),
      _vm.hasCheck && !_vm.isErrorPage && !_vm.isLinksPage
        ? _c("div", { attrs: { id: "footer" } }, [_c("Balance")], 1)
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }